import { useEffect, useState } from 'react';
import { useIntersection } from 'react-use';

interface Props {
  callback: () => void;
  observerProps?: IntersectionObserverInit;
  ready: boolean;
  ref: React.RefObject<HTMLElement>;
}

export default function useOnFirstView({
  callback,
  observerProps = {},
  ready,
  ref,
}: Props) {
  const [viewed, setViewed] = useState<boolean>(false);

  const entry = useIntersection(ref, observerProps);
  const isVisible = !!entry?.isIntersecting;

  useEffect(() => {
    if (isVisible && !viewed && ready) {
      setViewed(true);
      callback();
    }
  }, [ref?.current, observerProps]);

  return viewed;
}
